/**
 * Menu déroulant des tailles : ouvre la pop-up Klaviyo "retour en stock"
 * dès qu'on clique sur une taille en rupture, sans avoir à cliquer ensuite sur le CTA.
 *
 * Fonctionnement : le clic sélectionne la variante (comportement natif du thème).
 * Une fois la variante changée, le bouton d'achat se recharge en déclencheur Klaviyo
 * (.ax-klaviyo-bis-trigger, voir snippets/buy-buttons.liquid) : on le clique à sa place.
 */
(function () {
	'use strict';

	// Le snippet peut être inclus une fois par option : on ne s'installe qu'une seule fois.
	if (window.__axSizeDropdownBis) return;
	window.__axSizeDropdownBis = true;

	var WINDOW_MS = 5000;
	var WAIT_BEFORE_FIRST_LOOK_MS = 250;
	var POLL_MS = 120;

	var pending = false;
	var pendingUntil = 0;

	document.addEventListener('click', function (event) {
		var row = event.target.closest('[data-bis-row]');
		if (!row) return;

		var input = row.querySelector('input[type="radio"]');

		// Taille déjà sélectionnée : aucun "variant:change" ne suivra, on ouvre tout de suite.
		if (input && input.checked) {
			pending = false;
			openBackInStock();
			return;
		}

		pending = true;
		pendingUntil = Date.now() + WINDOW_MS;
	});

	// Émis par le thème une fois la variante ET l'URL à jour (Klaviyo lit l'URL).
	document.addEventListener('variant:change', function () {
		if (!pending) return;
		pending = false;
		if (Date.now() > pendingUntil) return;
		openBackInStock();
	});

	function visibleTrigger() {
		var triggers = document.querySelectorAll('.ax-klaviyo-bis-trigger');
		for (var i = 0; i < triggers.length; i++) {
			if (triggers[i].offsetParent !== null) return triggers[i];
		}
		return null;
	}

	function openBackInStock() {
		var deadline = Date.now() + WINDOW_MS;

		var tick = function () {
			// L'iframe Klaviyo doit exister, sinon le clic est perdu.
			if (document.getElementById('klaviyo-bis-iframe')) {
				var trigger = visibleTrigger();
				if (trigger) {
					trigger.click();
					return;
				}
			}
			if (Date.now() < deadline) setTimeout(tick, POLL_MS);
		};

		// On laisse le bouton d'achat se recharger avant de le chercher.
		setTimeout(tick, WAIT_BEFORE_FIRST_LOOK_MS);
	}
})();
